import { selectIsUserAgent } from 'shared/packages/Filters/shared/selectors';

import { IAppState } from '../../common/state';

import { selectSpecialPromoBuilderOffers } from './selectSpecialPromoBuilderOffers';

export function selectIsSpecialProjectAdfoxBannerVisible(state: IAppState): boolean {
  const isUserAgent = selectIsUserAgent(state);

  if (!isUserAgent) {
    return false;
  }

  const specialPromoBuilderOffers = selectSpecialPromoBuilderOffers(state);

  return !!specialPromoBuilderOffers?.needShowAdfoxBlock;
}
